
import { Options, prop, Vue } from "vue-class-component";
import { formatPriceRP, formatPriceRM } from "@/app/infrastructures/misc/Utils";

class Props {
  commissionRate = prop<number>({ required: true, type: Number });
  commissionAmount = prop<number>({ required: true, type: Number });
  agentDiscountRevealed = prop<boolean>({ default: false, type: Boolean });
  isAvailable = prop<boolean>({ default: true, type: Boolean });
  isEmbargo = prop<boolean>({ default: false, type: Boolean });
  currencyPrefix = prop<string>({ required: true, type: String, default: "Rp" });
}

@Options({
  name: "DiscountAgentBadgeV4"
})
export default class DiscountAgentBadgeV4 extends Vue.with(Props) {
  get shouldMask(): boolean {
    return !this.agentDiscountRevealed || !this.isAvailable || this.isEmbargo;
  }

  get formattedAmount(): string {
    return this.currencyPrefix === "RM"
      ? formatPriceRM(this.commissionAmount)
      : formatPriceRP(this.commissionAmount);
  }
}
